export const resolveSelectionDataSource = (source, row = {}, form = {}) =>
  source?.replace(/{([^}]+)}/g, (match, field) => {
    const value = row?.[field] ?? form?.[field];
    return value === undefined || value === null || value === "" ? match : value;
  });

export const applySelectionMapping = (
  row,
  record,
  mapping = {},
  columnToField = {},
) => {
  const hydratedRow = { ...row };

  Object.entries(mapping).forEach(([sourceField, targetColumn]) => {
    const targetField = columnToField[targetColumn] || targetColumn;
    hydratedRow[targetField] = record?.[sourceField] ?? "";
  });

  return hydratedRow;
};
